import {
  emailRegex, phone, zipRegex, phoneMask, poBox, validChar, letter,
} from './ruleRegex'

export default {
  required(flag, value) {
    return flag && !value
  },
  reCaptcha(flag, value) {
    return flag && !value
  },
  dropRequire(flag) {
    return flag
  },
  min(count, value = '') {
    return value.length <= parseInt(count, 10)
  },
  max(count, value = '') {
    return value.length > parseInt(count, 10)
  },
  email(flag, value) {
    return flag && !emailRegex.test(value)
  },
  phone(flag, value) {
    return flag && !phone.test(value)
  },
  phoneMask(flag, value) {
    return flag && !phoneMask.test(value)
  },
  compare(flag, value, data) {
    const { key } = flag
    const compareValue = data[key]
    return value !== compareValue
  },
  zipcode(flag, value) {
    return flag && !zipRegex.test(value)
  },
  poBox(flag, value) {
    return flag && poBox.test(value)
  },
  letter(flag, value) {
    if (value && validChar.test(value)) return flag && !letter.test(value)
    return false
  },
  validChar(flag, value) {
    if (value) return flag && !validChar.test(value)
    return false
  },
}
